import { render, staticRenderFns } from "./gameNode.vue?vue&type=template&id=024ce476&scoped=true"
import script from "./gameNode.vue?vue&type=script&lang=js"
export * from "./gameNode.vue?vue&type=script&lang=js"
import style0 from "./gameNode.vue?vue&type=style&index=0&id=024ce476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024ce476",
  null
  
)

export default component.exports